/**
 * components/empty.tsx — the design's `.t-empty` dashed empty state.
 */
import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { LightColors as C, Radii as R, FontSize as FS, FontWeight as FW } from '../theme/theme';
import { Txt } from './ui';

export interface EmptyProps {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

const Empty: React.FC<EmptyProps> = ({ title, children, icon, actions, style }) => (
  <View
    style={[
      {
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: C.lineStrong,
        borderRadius: R.r3,
        paddingVertical: 56,
        paddingHorizontal: 24,
        alignItems: 'center',
        backgroundColor: C.paper2,
      },
      style,
    ]}
  >
    {icon}
    <Txt size={FS.lg} weight={FW.semibold} color={C.ink2} align="center" style={{ marginBottom: 4 }}>
      {title}
    </Txt>
    {typeof children === 'string' ? (
      <Txt size={FS.md} color={C.ink3} align="center" style={{ maxWidth: 380, lineHeight: 20 }}>
        {children}
      </Txt>
    ) : (
      children
    )}
    {actions ? <View style={{ marginTop: 18 }}>{actions}</View> : null}
  </View>
);

export default Empty;
